import { render, staticRenderFns } from "./jigong.vue?vue&type=template&id=69ebebc9&scoped=true&"
import script from "./jigong.vue?vue&type=script&lang=js&"
export * from "./jigong.vue?vue&type=script&lang=js&"
import style0 from "./jigong.vue?vue&type=style&index=0&id=69ebebc9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ebebc9",
  null
  
)

export default component.exports